import domReady from '@wordpress/dom-ready';
import { render, useEffect } from '@wordpress/element';

const App = ( { attributes } ) => {
	const { title, selector, filters } = attributes;

	useEffect( () => {
		const pluginsCardWrapper = document.querySelector( `.${ selector }` );

		if ( pluginsCardWrapper ) {
			const blockElement = document.querySelector(
				'.wp-block-do-blocks-compatible-plugin-block'
			);
			const totalHeight =
				pluginsCardWrapper.offsetTop +
				pluginsCardWrapper.offsetHeight -
				300;

			function callback() {
				if ( window.scrollY < pluginsCardWrapper.offsetTop ) {
					blockElement.classList.remove(
						'wp-block-do-blocks-compatible-plugin-block-fixed'
					);
				} else if ( window.scrollY > totalHeight ) {
					blockElement.classList.remove(
						'wp-block-do-blocks-compatible-plugin-block-fixed'
					);
				} else if ( window.scrollY > pluginsCardWrapper.offsetTop ) {
					blockElement.classList.add(
						'wp-block-do-blocks-compatible-plugin-block-fixed'
					);
				}
			}

			window.addEventListener( 'scroll', callback );
		}
	}, [] );

	return (
		<div className="compatible-sidebar-container">
			<div className="compatible-sidebar">
				<h3 className="compatible-sidebar-title">{ title }</h3>
				<nav className="compatible-sidebar-nav">
					<ul className="nav">
						{ filters &&
							filters?.map( ( filter ) => (
								<li key={ filter.id }>
									<a href={ `#${ filter.anchor }` }>
										{ filter.title }
									</a>
								</li>
							) ) }
					</ul>
				</nav>
			</div>
		</div>
	);
};

domReady( () => {
	const mountWrap = document.querySelector(
		'.wp-block-do-blocks-compatible-plugin-block'
	);
	const attributes = mountWrap.getAttribute( 'data-attributes' );
	render( <App attributes={ JSON.parse( attributes ) } />, mountWrap );
} );
